// Variable global para almacenar el intervalo del contador
let countdownInterval = null;

// Variable global para cachear el estado de feriado
let isHolidayCache = null;
let holidayCacheTime = null;

// Función para calcular la diferencia de días entre dos fechas (sin importar la hora)
function getDaysDiff(date1, date2) {
    const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    return Math.round((d1 - d2) / (1000 * 60 * 60 * 24));
}

// Función para detener cualquier intervalo activo
function stopCountdown() {
    if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
    }
}

// ========== FUNCIÓN PARA VERIFICAR DÍAS FERIADOS ==========

/**
 * Verifica si hoy es un día feriado en Chile usando la API de Boostr
 * @returns {Promise<boolean>} - Promesa que resuelve a true si es feriado, false si no lo es
 */
async function checkIfHoliday() {
    const now = new Date();
    const currentTime = now.getTime();
    
    // Cache por 1 hora para evitar demasiadas llamadas a la API
    if (isHolidayCache !== null && holidayCacheTime && (currentTime - holidayCacheTime) < 3600000) {
        return isHolidayCache;
    }
    
    try {
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        
        console.log(`Verificando si ${day}/${month}/${year} es feriado...`);
        
        // API de Boostr para verificar días feriados
        const response = await fetch(`https://api.boostr.cl/holidays.json`);
        const data = await response.json();
        
        // Buscar si la fecha actual está en la lista de feriados
        const today = `${year}-${month}-${day}`;
        const isHoliday = data.data && data.data.some(holiday => holiday.date === today);
        
        console.log(`Verificación de feriado: ${isHoliday ? 'Es feriado' : 'No es feriado'}`);
        
        // Actualizar cache
        isHolidayCache = isHoliday;
        holidayCacheTime = currentTime;
        
        return isHoliday;
    } catch (error) {
        console.error('Error al verificar si es día feriado:', error);
        // En caso de error, asumir que no es feriado
        return false;
    }
}

/**
 * Verifica si una fecha específica es un día feriado
 * @param {Date} date - La fecha a verificar
 * @returns {Promise<boolean>} - Promesa que resuelve a true si es feriado, false si no lo es
 */
async function checkIfDateIsHoliday(date) {
    try {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        // API de Boostr para verificar días feriados
        const response = await fetch(`https://api.boostr.cl/holidays.json`);
        const data = await response.json();
        
        // Buscar si la fecha está en la lista de feriados
        const checkDate = `${year}-${month}-${day}`;
        const isHoliday = data.data && data.data.some(holiday => holiday.date === checkDate);
        
        return isHoliday;
    } catch (error) {
        console.error('Error al verificar si la fecha es feriado:', error);
        // En caso de error, asumir que no es feriado
        return false;
    }
}

/**
 * Encuentra el próximo día hábil disponible (excluyendo domingo y feriados)
 * @param {Date} startDate - Fecha desde donde empezar a buscar
 * @returns {Promise<{date: Date, dayName: string}>} - Próximo día hábil y su nombre
 */
async function findNextBusinessDay(startDate) {
    const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    for (let i = 0; i <= 7; i++) {
        // Siempre crear un nuevo objeto Date, formato seguro y hora a 00:00:00
        let currentDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i);
        currentDate.setHours(0, 0, 0, 0);
        const dayOfWeek = currentDate.getDay();
        
        // Excluir domingo (día 0)
        if (dayOfWeek === 0) continue;
        
        // Verificar si es feriado
        const isHoliday = await checkIfDateIsHoliday(currentDate);
        if (isHoliday) continue;
        
        // Si llegamos aquí, es un día hábil válido (excluyendo domingo y feriados)
        return {
            date: new Date(currentDate),
            dayName: dayNames[dayOfWeek]
        };
    }
    
    // Si no encontramos ningún día hábil en 7 días, retornar lunes
    return {
        date: null,
        dayName: 'Lunes'
    };
}

// ========== FUNCIONES PARA MODALES ==========

// Función para mostrar modal FLASH
function showFlashModal() {
    const modal = document.getElementById('flash-modal');
    if (modal) {
        modal.style.display = 'block';
    }
}

// Función para mostrar modal EXPRESS
function showExpressModal() {
    const modal = document.getElementById('express-modal');
    if (modal) {
        modal.style.display = 'block';
    }
}

// Función para cerrar modales
function closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.style.display = 'none';
    }
}

// Event listeners para cerrar modales al hacer click fuera
window.onclick = function(event) {
    const flashModal = document.getElementById('flash-modal');
    const expressModal = document.getElementById('express-modal');
    
    if (event.target === flashModal) {
        flashModal.style.display = 'none';
    }
    if (event.target === expressModal) {
        expressModal.style.display = 'none';
    }
}

// ========== ENVÍO FLASH ==========

// Función para restaurar estilos del elemento
function restoreElementStyles() {
    const deliveryElement = document.getElementById("delivery-message");
    if (deliveryElement) {
        deliveryElement.style.display = 'block';
        deliveryElement.style.padding = '';
        deliveryElement.style.margin = '';
        deliveryElement.style.boxShadow = '';
        deliveryElement.style.background = '';
        deliveryElement.style.border = '';
        deliveryElement.style.height = '';
        deliveryElement.style.width = '';
        deliveryElement.style.overflow = '';
        // Asegurarse de que no tenga la clase hidden-delivery
        deliveryElement.classList.remove('hidden-delivery');
    }
}

// Función para obtener el mensaje según la hora y día
async function getDeliveryMessage(service) {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentDay = now.getDay();
    const isSaturday = currentDay === 6;
    const isSunday = currentDay === 0;
    const currentTime = currentHour * 60 + currentMinutes;
    const sundayCutoff = 14 * 60; // Domingo 14:00 (2 PM)
    
    // Verificar si es un día feriado o domingo después del cutoff (no laboral)
    const isTodayHoliday = await checkIfHoliday();
    if (isTodayHoliday || (isSunday && currentTime >= sundayCutoff)) {
        // Si hoy es feriado o domingo después del cutoff, encontrar el próximo día hábil (desde mañana)
        const tomorrow = new Date(now);
        tomorrow.setDate(now.getDate() + 1);
        const nextBusinessDay = await findNextBusinessDay(tomorrow);
        const nextDayName = nextBusinessDay.dayName;
        const daysDiff = nextBusinessDay.date ? getDaysDiff(nextBusinessDay.date, now) : 0;
        return {
            message: service === 'flash' ? "ENVÍO FLASH" : "ENVÍO EXPRESS",
            showCountdown: false,
            showTomorrow: true,
            tomorrowMessage: daysDiff === 1 ?
                (service === 'flash' ? `LLEGA MAÑANA ${nextDayName.toUpperCase()} ANTES DE LAS 12:30 PM` : `LLEGA MAÑANA ${nextDayName.toUpperCase()} DURANTE EL DIA`)
                : (service === 'flash' ? `LLEGA EL ${nextDayName.toUpperCase()} ANTES DE LAS 12:30 PM` : `LLEGA EL ${nextDayName.toUpperCase()} DURANTE EL DIA`)
        };
    }
    // De 0:00 a 10:00 - "Llega hoy antes de las 12:30pm" (incluye sábados y domingos)
    if (currentHour >= 0 && currentHour < 10) {
        const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const todayName = dayNames[currentDay];
        return {
            message: service === 'flash' ? "ENVÍO FLASH" : "ENVÍO EXPRESS",
            showCountdown: false,
            showTomorrow: true,
            tomorrowMessage: service === 'flash' ? `LLEGA HOY ${todayName.toUpperCase()} ANTES DE LAS 12:30 PM` : `LLEGA HOY ${todayName.toUpperCase()} DURANTE EL DIA`
        };
    }
    // Después del cutoff
    const flashCutoff = isSunday ? 14 * 60 : (isSaturday ? 15 * 60 : 18 * 60); // Domingo 14:00, Sábado 15:00, Lun-Vie 18:00
    const expressCutoff = isSunday ? 14 * 60 : (isSaturday ? 15 * 60 : 18 * 60); // Domingo 14:00, Sábado 15:00, Lun-Vie 18:00
    if ((service === 'flash' && currentTime >= flashCutoff) || 
        (service === 'express' && currentTime >= expressCutoff)) {
        // Calcular el próximo día de entrega considerando feriados (incluyendo mañana)
        let nextDeliveryMessage;
        if (isSaturday) {
            // Si es sábado después del cutoff, la entrega es el próximo día hábil (lunes)
            const tomorrow = new Date(now);
            tomorrow.setDate(now.getDate() + 1);
            const nextBusinessDay = await findNextBusinessDay(tomorrow);
            const nextDayName = nextBusinessDay.dayName;
            // Si es sábado, el próximo día hábil es lunes (2 días después), siempre usar "EL LUNES"
            nextDeliveryMessage = (service === 'flash' ? `LLEGA EL ${nextDayName.toUpperCase()} ANTES DE LAS 12:30 PM` : `LLEGA EL ${nextDayName.toUpperCase()} DURANTE EL DIA`);
        } else if (isSunday) {
            // Si es domingo después del cutoff, la entrega es el próximo día hábil (lunes)
            const tomorrow = new Date(now);
            tomorrow.setDate(now.getDate() + 1);
            const nextBusinessDay = await findNextBusinessDay(tomorrow);
            const nextDayName = nextBusinessDay.dayName;
            // Si es domingo después del cutoff, el próximo día hábil es lunes, siempre usar "EL LUNES"
            nextDeliveryMessage = (service === 'flash' ? `LLEGA EL ${nextDayName.toUpperCase()} ANTES DE LAS 12:30 PM` : `LLEGA EL ${nextDayName.toUpperCase()} DURANTE EL DIA`);
        } else {
            // Para otros días, calcular el próximo día hábil (incluyendo mañana)
            const tomorrow = new Date(now);
            tomorrow.setDate(now.getDate() + 1);
            const nextBusinessDay = await findNextBusinessDay(tomorrow);
            const nextDayName = nextBusinessDay.dayName;
            const daysDiff = nextBusinessDay.date ? getDaysDiff(nextBusinessDay.date, now) : 0;
            nextDeliveryMessage = daysDiff === 1 ?
                (service === 'flash' ? `LLEGA MAÑANA ${nextDayName.toUpperCase()} ANTES DE LAS 12:30 PM` : `LLEGA MAÑANA ${nextDayName.toUpperCase()} DURANTE EL DIA`)
                : (service === 'flash' ? `LLEGA EL ${nextDayName.toUpperCase()} ANTES DE LAS 12:30 PM` : `LLEGA EL ${nextDayName.toUpperCase()} DURANTE EL DIA`);
        }
        return {
            message: service === 'flash' ? "ENVÍO FLASH" : "ENVÍO EXPRESS",
            showCountdown: false,
            showTomorrow: true,
            tomorrowMessage: nextDeliveryMessage
        };
    }
    // Durante el día - mostrar mensaje normal con countdown
    // Para sábado, mostrar "llega hoy" si estamos antes del cutoff
    if (isSaturday) {
        const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const todayName = dayNames[currentDay];
        return {
            message: service === 'flash' ? "LLEGA EN 2H CON ENVÍO FLASH" : "RECIBE HOY CON ENVÍO EXPRESS",
            showCountdown: true,
            showTomorrow: true,
            tomorrowMessage: service === 'flash' ? 
                `LLEGA HOY ${todayName.toUpperCase()} ANTES DE LAS 12:30 PM` : 
                `LLEGA HOY ${todayName.toUpperCase()} DURANTE EL DIA`,
            targetTime: service === 'flash' ? 
                new Date().setHours(15, 0, 0, 0) : // Sábado 15:00 para FLASH
                new Date().setHours(15, 0, 0, 0)    // Sábado 15:00 para EXPRESS
        };
    }
    // Para domingo, mostrar "llega hoy" si estamos antes del cutoff (14:00)
    if (isSunday) {
        const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const todayName = dayNames[currentDay];
        return {
            message: service === 'flash' ? "LLEGA EN 2H CON ENVÍO FLASH" : "RECIBE HOY CON ENVÍO EXPRESS",
            showCountdown: true,
            showTomorrow: true,
            tomorrowMessage: service === 'flash' ? 
                `LLEGA HOY ${todayName.toUpperCase()} ANTES DE LAS 12:30 PM` : 
                `LLEGA HOY ${todayName.toUpperCase()} DURANTE EL DIA`,
            targetTime: service === 'flash' ? 
                new Date().setHours(14, 0, 0, 0) : // Domingo 14:00 para FLASH
                new Date().setHours(14, 0, 0, 0)    // Domingo 14:00 para EXPRESS
        };
    }
    // Para lunes a viernes
    return {
        message: service === 'flash' ? "LLEGA EN 2H CON ENVÍO FLASH" : "RECIBE HOY CON ENVÍO EXPRESS",
        showCountdown: true,
        showTomorrow: false,
        targetTime: service === 'flash' ? 
            new Date().setHours(18, 0, 0, 0) : // Lun-Vie 18:00 para FLASH
            new Date().setHours(18, 0, 0, 0)    // Lun-Vie 18:00 para EXPRESS
    };
}

// Función para actualizar el contador FLASH
async function updateFlashCountdown(cutOffTime) {
    const now = new Date();
    let timeDifference = cutOffTime.getTime() - now.getTime();
    
    const deliveryInfo = await getDeliveryMessage('flash');
    timeDifference = Math.max(timeDifference, 0);
    const horasFaltantes = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutosFaltantes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const segundosFaltantes = Math.floor((timeDifference % (1000 * 60)) / 1000);

    const deliveryElement = document.getElementById("delivery-message");
    
    let html = `
        <div class="flash-banner">
            ${deliveryInfo.message}
            <span class="info-icon" onclick="showFlashModal()">
                <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
                    <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
                </svg>
            </span>
        </div>
        ${deliveryInfo.showCountdown && timeDifference > 0 ? 
            `<div class="countdown-title">Pide antes de <span class="remaining-time">${horasFaltantes}h ${minutosFaltantes}m ${segundosFaltantes}s</span></div>` 
            : ''}
        <div class="province-info">Sólo a 6km de Santiago Centro</div>
    `;
    
    deliveryElement.innerHTML = html;
    
    // Agregar modal FLASH si no existe
    if (!document.getElementById('flash-modal')) {
        const modalHtml = `
            <div id="flash-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close" onclick="closeModal('flash-modal')">&times;</span>
                    <div class="modal-header">
                        <h3>ENVIO FLASH</h3>
                        <p>Horario de corte:</p>
                        <p><strong>Lun a Vie hasta las 18:00 / Sab 15:00 / Dom 14:00</strong></p>
                    </div>
                    <div class="modal-body">
                        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
                        <a href="https://www.lifemaxstore.cl/policies/shipping-policy" target="_blank" rel="noopener noreferrer" class="more-info-link">Más Información</a>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }
}

// ========== ENVÍO EXPRESS ==========

// EXPRESS: mismo día
function showExpressSameDayDelivery() {
    stopCountdown();
    
    // Restaurar estilos del elemento
    restoreElementStyles();
    
    const now = new Date();
    const currentDay = now.getDay();
    const isSaturday = currentDay === 6;
    const isSunday = currentDay === 0;
    const cutOffTime = new Date();
    
    if (isSunday) {
        cutOffTime.setHours(14, 0, 0, 0); // Domingo 14:00
    } else if (isSaturday) {
        cutOffTime.setHours(15, 0, 0, 0); // Sábado 15:00
    } else {
        cutOffTime.setHours(18, 0, 0, 0); // Lun-Vie 18:00
    }
    
    updateExpressCountdown(cutOffTime);
    countdownInterval = setInterval(() => updateExpressCountdown(cutOffTime), 1000);
}

// Función para actualizar el contador EXPRESS
async function updateExpressCountdown(cutOffTime) {
    const now = new Date();
    let timeDifference = cutOffTime.getTime() - now.getTime();
    
    const deliveryInfo = await getDeliveryMessage('express');
    timeDifference = Math.max(timeDifference, 0);
    const horasFaltantes = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutosFaltantes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const segundosFaltantes = Math.floor((timeDifference % (1000 * 60)) / 1000);

    const deliveryElement = document.getElementById("delivery-message");
    
    let html = `
        <div class="express-banner">
            ${deliveryInfo.message}
            <span class="info-icon" onclick="showExpressModal()">
                <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
                    <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
                </svg>
            </span>
        </div>
        ${deliveryInfo.showCountdown && timeDifference > 0 ? 
            `<div class="countdown-title">Pide antes de <span class="remaining-time">${horasFaltantes}h ${minutosFaltantes}m ${segundosFaltantes}s</span></div>` 
            : ''}
        <div class="province-info">Sólo en la provincia de Santiago Urbano</div>
    `;
    
    deliveryElement.innerHTML = html;
    
    // Agregar modal EXPRESS si no existe
    if (!document.getElementById('express-modal')) {
        const modalHtml = `
            <div id="express-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close" onclick="closeModal('express-modal')">&times;</span>
                    <div class="modal-header">
                        <h3>ENVIO EXPRESS</h3>
                        <p>Horario de corte:</p>
                        <p><strong>Lun a Vie hasta las 18:00 / Sab 15:00 / Dom 14:00</strong></p>
                    </div>
                    <div class="modal-body">
                        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
                        <a href="https://www.lifemaxstore.cl/policies/shipping-policy" target="_blank" rel="noopener noreferrer" class="more-info-link">Más Información</a>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }
}

// ========== FUNCIÓN PARA VERIFICAR DISPONIBILIDAD ==========

function checkServiceAvailability() {
    const now = new Date();
    const currentDay = now.getDay();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTime = currentHour * 60 + currentMinute;
    
    let flashAvailable = false;
    let expressAvailable = false;
    
    // Verificar disponibilidad de FLASH y EXPRESS
    if (currentDay >= 1 && currentDay <= 5) { // Lunes a Viernes
        const flashCutoff = 18 * 60; // 18:00
        const expressCutoff = 18 * 60; // 18:00
        flashAvailable = currentTime < flashCutoff;
        expressAvailable = currentTime < expressCutoff;
    } else if (currentDay === 6) { // Sábado
        const saturdayCutoff = 15 * 60; // 15:00 para ambos servicios
        flashAvailable = currentTime < saturdayCutoff;
        expressAvailable = currentTime < saturdayCutoff;
    } else if (currentDay === 0) { // Domingo - laboral hasta las 14:00
        const sundayCutoff = 14 * 60; // 14:00 para ambos servicios
        flashAvailable = currentTime < sundayCutoff;
        expressAvailable = currentTime < sundayCutoff;
    }
    
    return { flashAvailable, expressAvailable };
}

// ========== FUNCIÓN PARA MOSTRAR AMBOS SERVICIOS ==========

function showBothServices() {
    stopCountdown();
    
    // Restaurar estilos del elemento
    restoreElementStyles();
    
    const now = new Date();
    const currentDay = now.getDay();
    const esSabado = currentDay === 6;
    const esDomingo = currentDay === 0;
    
    // Configurar horarios de corte
    const flashCutoff = new Date();
    const expressCutoff = new Date();
    
    if (esDomingo) {
        flashCutoff.setHours(14, 0, 0); // Domingo 14:00
        expressCutoff.setHours(14, 0, 0); // Domingo 14:00
    } else if (esSabado) {
        flashCutoff.setHours(15, 0, 0); // Sábado 15:00
        expressCutoff.setHours(15, 0, 0); // Sábado 15:00
    } else {
        flashCutoff.setHours(18, 0, 0); // Lun-Vie 18:00
        expressCutoff.setHours(18, 0, 0); // Lun-Vie 18:00
    }
    
    updateBothServicesCountdown(flashCutoff, expressCutoff);
    countdownInterval = setInterval(() => updateBothServicesCountdown(flashCutoff, expressCutoff), 1000);
}

async function updateBothServicesCountdown(flashCutoff, expressCutoff) {
    const now = new Date();
    
    // Calcular tiempo restante para FLASH y EXPRESS
    let flashTimeDiff = flashCutoff.getTime() - now.getTime();
    let expressTimeDiff = expressCutoff.getTime() - now.getTime();
    
    // Obtener información de mensajes para ambos servicios
    const flashInfo = await getDeliveryMessage('flash');
    const expressInfo = await getDeliveryMessage('express');
    
    // Calcular tiempos restantes
    flashTimeDiff = Math.max(flashTimeDiff, 0);
    expressTimeDiff = Math.max(expressTimeDiff, 0);
    
    const flashHours = Math.floor(flashTimeDiff / (1000 * 60 * 60));
    const flashMinutes = Math.floor((flashTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const flashSeconds = Math.floor((flashTimeDiff % (1000 * 60)) / 1000);
    
    const expressHours = Math.floor(expressTimeDiff / (1000 * 60 * 60));
    const expressMinutes = Math.floor((expressTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const expressSeconds = Math.floor((expressTimeDiff % (1000 * 60)) / 1000);
    
    const deliveryElement = document.getElementById("delivery-message");
    
    let html = `
        <div class="flash-banner">
            ${flashInfo.message}
            <span class="info-icon" onclick="showFlashModal()">
                <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
                    <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
                </svg>
            </span>
        </div>
        ${flashInfo.showCountdown && flashTimeDiff > 0 ? 
            `<div class="countdown-title">${flashInfo.showTomorrow ? flashInfo.tomorrowMessage + '<br>' : ''}Pide antes de <span class="remaining-time">${flashHours}h ${flashMinutes}m ${flashSeconds}s</span></div>` 
            : flashInfo.showTomorrow ? `<div class="countdown-title">${flashInfo.tomorrowMessage}</div>` : ''}
        <div class="province-info">Sólo a 6km de Santiago Centro</div>
        
        <div style="margin-top: 5px;">
            <div class="express-banner">
                ${expressInfo.message}
                <span class="info-icon" onclick="showExpressModal()">
                    <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
                        <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
                    </svg>
                </span>
            </div>
            ${expressInfo.showCountdown && expressTimeDiff > 0 ? 
                `<div class="countdown-title">${expressInfo.showTomorrow ? expressInfo.tomorrowMessage + '<br>' : ''}Pide antes de <span class="remaining-time">${expressHours}h ${expressMinutes}m ${expressSeconds}s</span></div>` 
                : expressInfo.showTomorrow ? `<div class="countdown-title">${expressInfo.tomorrowMessage}</div>` : ''}
            <div class="province-info">Sólo en la provincia de Santiago Urbano</div>
        </div>
    `;
    
    deliveryElement.innerHTML = html;
    
    // Agregar modales si no existen
    if (!document.getElementById('flash-modal')) {
        const flashModalHtml = `
            <div id="flash-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close" onclick="closeModal('flash-modal')">&times;</span>
                    <div class="modal-header">
                        <h3>ENVIO FLASH</h3>
                        <p>Horario de corte:</p>
                        <p><strong>Lun a Vie hasta las 18:00 / Sab 15:00 / Dom 14:00</strong></p>
                    </div>
                    <div class="modal-body">
                        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
                        <a href="https://www.lifemaxstore.cl/policies/shipping-policy" target="_blank" rel="noopener noreferrer" class="more-info-link">Más Información</a>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', flashModalHtml);
    }
    
    if (!document.getElementById('express-modal')) {
        const expressModalHtml = `
            <div id="express-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close" onclick="closeModal('express-modal')">&times;</span>
                    <div class="modal-header">
                        <h3>ENVIO EXPRESS</h3>
                        <p>Horario de corte:</p>
                        <p><strong>Lun a Vie hasta las 18:00 / Sab 15:00 / Dom 14:00</strong></p>
                    </div>
                    <div class="modal-body">
                        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
                        <a href="https://www.lifemaxstore.cl/policies/shipping-policy" target="_blank" rel="noopener noreferrer" class="more-info-link">Más Información</a>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', expressModalHtml);
    }
}

// ========== FUNCIÓN PRINCIPAL ACTUALIZADA ==========

function deliveryMessage(option) {
    stopCountdown();
    restoreElementStyles();
    
    // Siempre mostrar ambos servicios
    showBothServices();
}

// Asegurarse de que el elemento exista y sea visible al cargar la página
document.addEventListener('DOMContentLoaded', function() {
    const deliveryElement = document.getElementById("delivery-message");
    if (!deliveryElement) {
        // Si no existe el elemento, crearlo
        const container = document.createElement('div');
        container.id = 'delivery-message';
        container.className = 'delivery-message';
        document.body.insertBefore(container, document.body.firstChild);
    }
    
    // Iniciar los servicios
    deliveryMessage();
});

// Reiniciar los servicios cada minuto para mantener actualizado
setInterval(deliveryMessage, 60000);